import React, { FC, ReactNode, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { MenuItemProps } from '../../types';
import {
  Container,
  LayoutWrapper,
  Main,
  MainHeader,
  PageHeadline,
} from './Layout.styled';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';

interface LayoutProps {
    children: ReactNode;
    menuConfig? : MenuItemProps[];
}
export const Layout: FC<LayoutProps> = ({
  children,
  menuConfig,
}) => {
  const [showMobileNavigation, setShowMobileNavigation] = useState(false);
  const params = useParams();

  useEffect(() => {
    setShowMobileNavigation(false);
  }, [params]);

  return (
    <LayoutWrapper isMenuOpen={showMobileNavigation}>
      <Sidebar
        menuConfig={menuConfig}
        showMobile={showMobileNavigation}
        setShowMobile={() => setShowMobileNavigation(!showMobileNavigation)}
      />
      <PageHeadline>
        <MainHeader>
          <TopBar showMobileNavigation={() => setShowMobileNavigation(!showMobileNavigation)} />
        </MainHeader>
      </PageHeadline>
      <Main>
        <Container>
          {children}
        </Container>
      </Main>

    </LayoutWrapper>
  );
};
